import React from 'react'

import classNames from 'classnames'
import { FieldHookConfig, useField } from 'formik'

interface CustomProps {
  onClick?: VoidFunction
  falseLabel?: string
  trueLabel?: string
}

type ToggleFieldProps = CustomProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  FieldHookConfig<boolean>

/**
 * @deprecated use Formik > Field and customize at the feature level
 * @see useForm() hook
 */
const ToggleField = (props: ToggleFieldProps) => {
  const {
    falseLabel = 'No',
    trueLabel = 'Yes',
    onClick = () => {
      /*nothing*/
    },
  } = props
  const [field, , helpers] = useField(props)

  const outerClasses = classNames(
    { 'bg-success': field.value },
    { 'bg-gray-400': !field.value },
    'w-14 h-7 inline-flex items-center rounded-full mr-3 px-1 cursor-pointer'
  )

  const switchClasses = classNames(
    { 'translate-x-7': field.value },
    { 'translate-x-0': !field.value },
    'bg-white w-5 h-5 rounded-full shadow-md transform transition-transform'
  )

  return (
    <>
      <span className='inline-flex items-center'>
        {falseLabel && <span className='text-sm mr-3'>{falseLabel}</span>}
        <div
          {...props}
          {...field}
          onClick={() => helpers.setValue(!field.value)}
          className={outerClasses}
        >
          <div
            className={switchClasses}
            onClick={onClick}
          />
        </div>
        {trueLabel && <span className='text-sm'>{trueLabel}</span>}
      </span>
    </>
  )
}

export default ToggleField
